import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark' | 'system';

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

function applyTheme(theme: Theme) {
  const root = window.document.documentElement;
  root.classList.remove('light', 'dark');
  if (theme === 'system') {
    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    root.classList.add(systemTheme);
  } else {
    root.classList.add(theme);
  }
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },
    }),
    {
      name: 'clearring-theme',
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state.theme);
        // Listen for OS theme changes and re-apply when in system mode
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
          const currentTheme = useThemeStore.getState().theme;
          if (currentTheme === 'system') applyTheme('system');
        });
      },
    },
  ),
);
